import React from 'react'
import Img from 'gatsby-image'
import Image from '../../../components/image'
// import ModalVideo from '../../../components/ui/modal-video'
import {
    TimelineWrap,
    TimelineList,
    Line,
    Item,
    Dots,
    TimelineRow,
    TimelineFeature,
    TimelineFeatureInner,
    TimelineInfo,
    TimelineInfoInner,
    DateWrap, 
    Photo,
    TimelineContent,
    Title,
    Description
} from './style'
import Anchor from '../anchor'

const Timeline = ({ items}) => {


    
    // const [videoOpen, setVideoOpen] = useState(false);

    // const modalVideoOpen = () => {
    //     setVideoOpen(true)
    // }

    // const modalVideoClose = () => {
    //     setVideoOpen(false)
    // }
    return (
        <TimelineWrap>
            <TimelineList>
                <Line />
                {items && items.map((item, i) => {
                    const { year, path, image, title, desc } = item;
                    const gatsbyImg = image && image.childImageSharp;
                    const imageSrc = gatsbyImg || image;
                    let boxImage;
                    if (imageSrc.fixed && typeof imageSrc.fixed !== 'function') {
                        boxImage = <Img fixed={imageSrc.fixed} alt="popup video" />;
                    } else if (imageSrc.fluid) {
                        boxImage = <Image fluid={imageSrc.fluid} alt="popup video" />
                    } else {
                        boxImage = <img src={imageSrc} alt="popup video" />
                    }
                    return (
                        <Item key={`timeline-${i}`} align={i % 2 === 0 ? 'left' : 'right'}>
                            <Dots />
                            <TimelineRow>
                                <TimelineFeature>
                                    <TimelineFeatureInner>
                                        {year && <DateWrap>{year}</DateWrap>}
                                       
                                        {/* <VideoBoxWrap>
                                            <VideoBtnWrap> */}

                                                {/* <VideoButton skin="primary" onClick={modalVideoOpen} /> */}
                                            {/* </VideoBtnWrap>
                                        </VideoBoxWrap> */}
                                        {imageSrc && <Photo >{boxImage}</Photo>}
                                    </TimelineFeatureInner>
                                </TimelineFeature>
                                <TimelineInfo>
                                    <TimelineInfoInner>
                                        <TimelineContent>
                                            {title && <Title>{title}</Title>}
                                            {desc && <Description>{desc}</Description>}
                                            <Anchor path={path} >Read more </Anchor>
                                        </TimelineContent>
                                    </TimelineInfoInner>
                                </TimelineInfo>
                            </TimelineRow>
                        </Item>
                    )
                })}

            </TimelineList>
            {/* <ModalVideo
                // channel='youtube'
                // videoId={video_id}
                isOpen={videoOpen}
                onClose={modalVideoClose}
            /> */}
        </TimelineWrap>
    )
}




export default Timeline
